import React, { useRef } from 'react';

interface CheckboxProps {
    label: string;
    required?: boolean
    defaultChecked?: boolean
    onChange?: (checked: boolean) => void;
    checked?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
    label,
    required,
    onChange,
    defaultChecked,
    checked
}) => {

    const checkBoxRef = useRef<HTMLInputElement>(null);

    return (
        <div className='flex items-center'>
            <input
                ref={checkBoxRef}
                type='checkbox'
                className='focus:outline-none'
                onChange={(e) => onChange && onChange(e.target.checked)}
                required={required}
                defaultChecked={defaultChecked}
                checked={checked}
            />
            <label className=' font-Poppins font-medium text-base ms-2 text-light-primary select-none' onClick={() => {
                if (checkBoxRef.current) {
                    checkBoxRef.current.checked = !checkBoxRef.current.checked
                    onChange && onChange(checkBoxRef.current.checked)
                }
            }}>{label}</label>
        </div>
    );

};

export default Checkbox;